import PieGraph from './PieGraph'

export default PieGraph
